"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlueprintStockedProductCard = void 0;
const React = require("react");
const react_1 = require("react");
const Currency_1 = require("../../../../../components/base/atoms/Currency");
const CircularIcon_1 = require("../../../../../components/base/atoms/CircularIcon");
const standardSizes_1 = require("../../../../../types/standardSizes");
const Img_1 = require("../../../../../components/base/atoms/Img");
const colors_1 = require("../../../../../types/colors");
const Badge_1 = require("../../../../../components/base/atoms/Badge");
const ProductDietaryInfo_1 = require("../ProductDietaryInfo");
const constants_1 = require("../../helpers/constants");
const useBlueprintStockedProductSelectionState_1 = require("../../hooks/useBlueprintStockedProductSelectionState");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
// INFO This file is currently not used
const css = (0, cssComposer_1.default)(styles, "BlueprintStockedProductCard");
/**
 * Component for displaying a BlueprintStockedProduct model
 * with controls to adjust the quantity.
 */
const BlueprintStockedProductCard = ({ salesOrderItemBuilt, blueprintStockedProduct, onAddClick, onRemoveClick, removeAllSelections }) => {
    const { selectedProducts, productBlueprint: { productAvailabilityMap } } = salesOrderItemBuilt;
    const { productId, title, imageUrl, retailPrice, spiciness } = blueprintStockedProduct;
    const availability = (0, react_1.useMemo)(() => productAvailabilityMap.get(productId), [
        productAvailabilityMap,
        productId
    ]);
    const selectedProduct = selectedProducts.find(sp => sp.product.productId === productId);
    const quantity = selectedProduct === undefined ? 0 : selectedProduct.quantity;
    const isSelected = quantity > 0;
    const { disabled, canAdd, isAlwaysExtra } = availability;
    // states of ingredient
    const { removable, addable } = (0, useBlueprintStockedProductSelectionState_1.useSalesOrderDetailsForCurrentTime)(salesOrderItemBuilt, blueprintStockedProduct);
    // what happens when ingredient is pressed
    const onClick = removable
        ? // just remove selection
            onRemoveClick
        : // remove all current selections and add one that was pressed
            addable
                ? () => {
                    removeAllSelections();
                    onAddClick();
                }
                : null;
    return (React.createElement("div", { className: css("", {
            "-selected": isSelected,
            "-canAdd": canAdd,
            "-disabled": disabled
        }), onClick: onClick },
        React.createElement("div", { className: css("item") },
            React.createElement(Img_1.Img, { responsive: true, className: css("image"), src: imageUrl }),
            isSelected && (React.createElement(CircularIcon_1.CircularIcon, { className: css("selected"), variant: colors_1.TColorVariants.Primary, name: "tick", isActive: true, size: standardSizes_1.TStandardSizes.ExtraSmall })),
            React.createElement("div", { className: css("extraPriceContainer") }, isAlwaysExtra && retailPrice > 0 && (React.createElement(Badge_1.Badge, { size: standardSizes_1.TStandardSizes.Small },
                "+",
                React.createElement(Currency_1.Currency, null, retailPrice))))),
        React.createElement(ProductDietaryInfo_1.ProductDietaryInfo, { product: blueprintStockedProduct }),
        React.createElement("div", { className: css("description") },
            React.createElement("div", null,
                React.createElement("label", null, title))),
        spiciness > 0 && (React.createElement("div", null, [...Array(spiciness)].map((level, index) => (React.createElement(Img_1.Img, { key: `spicy-${index + 1}`, src: constants_1.spicinessImage, className: css("spiciness") })))))));
};
exports.BlueprintStockedProductCard = BlueprintStockedProductCard;
//# sourceMappingURL=index.js.map